export const formatINR = (n) => "₹" + Math.round(Number(n) || 0).toLocaleString("en-IN");

// Compact INR for large targets: >= 1 crore -> "₹25 Cr", >= 1 lakh -> "₹40 L", else full.
export const formatCr = (n) => {
  const v = Number(n) || 0;
  if (v >= 1e7) {
    const cr = v / 1e7;
    return "₹" + (Number.isInteger(cr) ? cr : cr.toFixed(2).replace(/\.?0+$/, "")) + " Cr";
  }
  if (v >= 1e5) return "₹" + (v / 1e5).toFixed(2).replace(/\.?0+$/, "") + " L";
  return "₹" + Math.round(v).toLocaleString("en-IN");
};

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
export const resolveImg = (url) => {
  if (!url) return "";
  return url.startsWith("/api") ? `${BACKEND}${url}` : url;
};
